var a = /* @__PURE__ */ ((r) => (r.LOGO = "logo", r.BUBBLE = "bubble", r.QUESTION_MARK = "question_mark", r.WHATSAPP = "whatsapp", r))(a || {});
export {
  a as WidgetSetupIcon
};
